module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7SZIB"))).then(() => module.bundle.root('d0iPb'));